var indentStyle = {"indentZero":"AAej5","indentOne":"gm-Fs","indentTwo":"jGF3J","indentThree":"Aqm1n","indentFour":"C3cIN","indentFive":"gK82R","indentSix":"tJgh2"};

export { indentStyle as i };
//# sourceMappingURL=indentation-bcdb02ca.js.map
